import React from "react";
import SummarySidebar from "./SummarySidebar";
import TypeOfPaper from "./sections/TypeOfPaper";
import Discipline from "./sections/Discipline";
import AcademicLevel from "./sections/AcademicLevel";
import Deadline from "./sections/Deadline";
import HighPriority from "./sections/HighPriority";
import Page from "./sections/Page";
import Slide from "./sections/Slide";
import Spacing from "./sections/Spacing";
import PaperFormat from "./sections/PaperFormat";
import {useSelector} from "react-redux";
import useIsMobile from "../helpers/MobileHelper";
import Problem from "./sections/Problem";
import Question from "./sections/Question";
import VisualPiece from "./sections/VisualPiece";
import {useFormState} from "react-final-form";

function PaperDetailsPage() {
    const showSummary = useSelector((state) => state.summary.status);
    const isMobile = useIsMobile();
    const {errors} = useFormState();

    return <div className="main-wrap with-single-btn_v3">
        <div className="container_v3">
            <main className="main-content">
                <div className="form-wrap">
                    <div className="form-validation">
                        <div className="page-title_v3">Paper details</div>
                        <TypeOfPaper/>
                        <Discipline/>
                        <AcademicLevel/>
                        <div className="form-row">
                            <Deadline/>
                            <HighPriority/>
                        </div>
                        <div className="form-row m-0">
                            <Page/>
                            <Slide/>
                        </div>
                        <div className="form-row m-0">
                            <Problem/>
                            <VisualPiece/>
                        </div>
                        <div className="form-row m-0">
                            <Question/>
                        </div>
                        {errors.page || errors.slide || errors.question || errors.problem || errors.visualPiece ? (
                            <div className="form-error" style={{marginBottom: '16px', color: '#FF5252', fontSize: '14px'}}>
                                {errors.page || errors.slide || errors.question || errors.problem || errors.visualPiece}
                            </div>
                        ) : null}
                        <Spacing/>
                        <PaperFormat menuPlacement="top"/>
                        {isMobile && (
                            <div className="form-group">
                                <div className="form-btn_v3">
                                    <button className="btn_v3 btn_v3_next btn_v3-md btn_v3-primary btn_v3-with-icon"
                                            style={{width: '100%'}}>
                                        Next
                                        <span className="btn_v3__icon">
                                        <img src="/_core/assets/themes/v5/assets/img/form3/arrow-long-right.svg" alt=""/>
                                    </span>
                                    </button>
                                </div>
                            </div>
                        )}
                        {isMobile && (
                            <div className={`form-bottom-panel ${showSummary ? 'active' : ''}`}>
                                {isMobile && (<SummarySidebar/>)}
                            </div>
                        )}
                    </div>
                </div>
            </main>
            {!isMobile && (<SummarySidebar/>)}
        </div>
    </div>
}

export default PaperDetailsPage;